import { useCallback } from "react";

import logger from "~/helpers/logger";
import snackMessages from "~/helpers/snackMessages";
import { useSnacks } from "~/providers/SnackProvider";

export interface UseSaveLocalPreferenceReturn {
	(save: () => void): boolean;
}

const useSaveLocalPreference = (): UseSaveLocalPreferenceReturn => {
	const [openSnack] = useSnacks();
	return useCallback(
		(save: () => void): boolean => {
			try {
				save();
				return true;
			} catch (error) {
				const message = snackMessages.localPreferenceSaveError;
				logger.error(message, error);
				openSnack(message, "error", false, undefined, undefined, { skipLog: true });
				return false;
			}
		},
		[openSnack]
	);
};

export default useSaveLocalPreference;
